<script>
    import router from "page";

    import { fly } from "svelte/transition";

    import { onMount } from "svelte";

    import { clickOutside } from "../utils/clickOutside.js";

    import { isMobile, showSidebar, categories } from "../stores.js";
    import { fetchGet } from "../utils/utilsFetch.js";

    onMount(async () => {
        $categories = await fetchGet("/api/categories");
    });

    let activeTop;
    let activeMid;
</script>

<div
    class="container"
    class:visible={$showSidebar}
    in:fly={{ x: -300, duration: 500 }}
    out:fly={{ x: -300, duration: 500 }}
    on:mouseleave={() => {
        if (!activeMid) {
            activeTop = null;
            activeMid = null;
        }
    }}
    use:clickOutside
    on:click-outside={() => {
        activeTop = null;
    }}
>
    {#if $categories}
        <div class="tops list">
            {#each $categories as top}
                <div
                    class="top list-item"
                    on:mouseenter={() => {
                        if ($isMobile) return;
                        activeMid = null;
                        activeTop = top;
                    }}
                    on:click={() => {
                        if (!$isMobile) return;

                        if (activeTop?.name == top?.name) {
                            activeTop = null;
                        } else {
                            activeMid = null;
                            activeTop = top;
                        }
                    }}
                >
                    {top.name}
                </div>
            {/each}
        </div>
    {/if}

    {#if activeTop}
        <div class="mids list">
            {#each activeTop.children as mid}
                <div
                    class="mid list-item"
                    on:mouseenter={() => {
                        if (activeTop) {
                            if ($isMobile) return;
                            activeMid = mid;
                        }
                    }}
                    on:click={() => {
                        if (activeTop) {
                            if (!$isMobile) return;
                            if (activeMid?.name == mid?.name) {
                                activeMid = null;
                            } else {
                                activeMid = mid;
                            }
                        }
                    }}
                >
                    {mid.name}
                </div>
            {/each}
        </div>
    {/if}

    {#if activeMid}
        <div
            class="categories list"
            on:mouseleave={() => {
                activeMid = null;
            }}
        >
            {#each activeMid.children as category}
                <a href="/products?category={category}">
                    <div class="category list-item">
                        {category}
                    </div>
                </a>
            {/each}
        </div>
    {/if}
</div>

<style>
    .container {
        grid-column: 1/2;
        grid-row: 2/-1;

        display: flex;
        z-index: 97;

        font-size: 14px;

        z-index: 2;

        display: none;
    }

    .visible {
        display: flex;
    }

    .tops {
        height: calc(100vh - 50px);
        width: 300px;
        position: relative;
        box-shadow: 0px 0px 5px #888;
    }

    .mids {
        height: calc(100vh - 50px);
        grid-row: 2/-1;
        position: absolute;
        width: 200px;
        left: 200px;
        box-shadow: 0px 0px 5px #888;
    }

    .categories {
        height: calc(100vh - 50px);
        grid-row: 2/-1;
        position: absolute;
        width: 200px;
        left: 400px;
        box-shadow: 0px 0px 5px #888;
    }

    .list {
        background: #eee;
    }

    .list-item {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #ccc;
        cursor: pointer;

        padding: 7px 10px;
    }

    .list-item:hover {
        background: #ddd;
    }

    @media only screen and (max-device-width: 600px) {
        .mids {
            left: 70px;
        }

        .categories {
            left: 160px;
        }
    }
</style>
